export const FETCH_ROUTE_REQUEST = 'FETCH_ROUTE_REQUEST';
export const FETCH_ROUTE_SUCCESS = 'FETCH_ROUTE_SUCCESS';
export const FETCH_ROUTE_FAILURE = 'FETCH_ROUTE_FAILURE';

export const ADD_ROUTE_REQUEST = 'ADD_ROUTE_REQUEST';
export const ADD_ROUTE_SUCCESS = 'ADD_ROUTE_SUCCESS';
export const ADD_ROUTE_FAILURE = 'ADD_ROUTE_FAILURE';

export const UPDATE_ROUTE_REQUEST = 'UPDATE_ROUTE_REQUEST';
export const UPDATE_ROUTE_SUCCESS = 'UPDATE_ROUTE_SUCCESS';
export const UPDATE_ROUTE_FAILURE = 'UPDATE_ROUTE_FAILURE';

export const DELETE_ROUTE_REQUEST = 'DELETE_ROUTE_REQUEST';
export const DELETE_ROUTE_SUCCESS = 'DELETE_ROUTE_SUCCESS';
export const DELETE_ROUTE_FAILURE = 'DELETE_ROUTE_FAILURE';

export const ROUTE_FORM_ERROR = 'ROUTE_FORM_ERROR';
export const ROUTE_FORM_SUCCESS = 'ROUTE_FORM_SUCCESS';
export const SET_ROUTE_EDIT = 'SET_ROUTE_EDIT';
export const CLEAR_ROUTE_EDIT = 'CLEAR_ROUTE_EDIT';